import { UserData } from '@/common/auth/user-data';

export const LocalStoragePlugin = store => {
    const userData = UserData.getUserDataFromLocalStorage();
    if (userData) {
        store.dispatch('saveUserInfo', userData);

    }
};


// WEBPACK FOOTER //
// ./src/store/plugins/local-storage.plugin.js